import { Grid, Button, Card, CardContent, Typography, Box, Container, Paper } from "@mui/material";
import { Buttons } from "./LoggedIn";
import DeviceView from "./DeviceView";
import { NavLink } from "react-router-dom";
import AuthStore from "../stores/AuthStore";
import { observer } from "mobx-react";

const LandingView = observer(() => (
    <Container maxWidth="xl" sx={{ py: 4, height: "100%" }}>
        <Grid container spacing={3} sx={{ height: "100%" }}>
            <Grid item xs={12} md={AuthStore.hasAdmin ? 6 : 12}>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 500 }}>
                    Manager Portal
                </Typography>
                <Grid container spacing={2}>
                    {Buttons()
                        .filter((it) => !it.disabled)
                        .map((it) => (
                            <Grid
                                item
                                xs={6}
                                sm={4}
                                md={AuthStore.hasAdmin ? 6 : 3}
                                lg={AuthStore.hasAdmin ? 4 : 2}
                                key={`landing-button-${it.title}`}
                            >
                                <NavLink to={it.disabled ? "/" : it.to} style={{ textDecoration: "none" }}>
                                    <Paper
                                        elevation={2}
                                        sx={{
                                            p: 3,
                                            cursor: "pointer",
                                            transition: "all 0.3s ease",
                                            borderRadius: 2,
                                            height: "100%",
                                            minHeight: 140,
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 2,
                                            "&:hover": {
                                                transform: "translateY(-4px)",
                                                boxShadow: 6,
                                                backgroundColor: "action.hover",
                                            },
                                        }}
                                    >
                                        <Box sx={{ color: "primary.main" }}>{it.largeIcon}</Box>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                textAlign: "center",
                                                fontWeight: 500,
                                                color: "text.primary",
                                            }}
                                        >
                                            {it.title}
                                        </Typography>
                                    </Paper>
                                </NavLink>
                            </Grid>
                        ))}
                </Grid>
            </Grid>
            {AuthStore.hasAdmin && (
                <Grid item xs={12} md={6}>
                    <Typography variant="h4" sx={{ mb: 3, fontWeight: 500 }}>
                        Device Management
                    </Typography>
                    <Paper
                        elevation={2}
                        sx={{
                            height: 800,
                            maxHeight: "calc(100vh - 250px)",
                            overflow: "hidden",
                            borderRadius: 2,
                            p: 3,
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Box sx={{ flex: 1, overflowY: "auto" }}>
                            <DeviceView />
                        </Box>
                    </Paper>
                </Grid>
            )}
        </Grid>
    </Container>
));

export default LandingView;
